// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initialValues: any = {
  data: [],
};
